var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _path2, _path3, _circle13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTatConfigurations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8026 41.7742L42.1237 35.8043L45.8695 38.3795C49.5217 38.9414 51.1371 36.8968 51.4882 35.8043V31.9414H60.5016V35.8043C62.2809 38.9882 65.301 38.8478 66.5886 38.3795L69.2809 35.8043L75.0167 41.7742L72.5585 44.7006C72.0903 48.0718 74.0022 50.0072 75.0167 50.5534L79.1137 51.3728V59.918H76.4214C72.02 60.3862 72.4024 64.3271 73.1438 66.2391L75.0167 68.5802L69.0468 74.7842L65.7692 72.0919C61.6488 71.1554 60.2285 74.0429 60.0334 75.6036V78.53H51.3712V74.7842C49.5919 70.9447 46.1817 71.7798 44.6989 72.6772L42.1237 74.7842L36.3879 68.5802L38.3779 66.2391C39.9698 62.4932 37.7146 60.0741 36.3879 59.3327H32.6421V50.5534H36.3879C39.1973 49.8043 38.8851 46.3394 38.3779 44.7006L35.8026 41.7742Z",
    fill: "url(#paint0_linear_6467_570)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4682,
    cy: 41.1866,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4682,
    cy: 69.7491,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4449,
    cy: 43.5264,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2108,
    cy: 68.1085,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2944,
    cy: 62.7256,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.1873,
    cy: 55.6983,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2944,
    cy: 48.4444,
    r: 0.819398,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 63.5452 42.707)",
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 56.5217 68.9258)",
    fill: "#D9D9D9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 63.7793 67.2891)",
    fill: "#D9D9D9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 68.6957 61.9062)",
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 70.8027 54.8789)",
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.819398,
    cy: 0.819398,
    r: 0.819398,
    transform: "matrix(-1 0 0 1 68.6957 47.625)",
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7024,
    cy: 55.4663,
    r: 1.72408,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4683 44.9336V53.2446",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.99 56.9883L61.5552 61.5535",
    stroke: "white",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 33,
    stroke: "url(#paint1_linear_6467_570)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6467_570",
    x1: 55.8779,
    y1: 31.9414,
    x2: 55.8779,
    y2: 78.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2474D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08B4CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6467_570",
    x1: 55,
    y1: 20,
    x2: 55,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0595B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTatConfigurations);
export default __webpack_public_path__ + "static/media/tatConfigurations.5d76d523bff31afc19d8604c182197e6.svg";
export { ForwardRef as ReactComponent };